import React from 'react';
import * as FiIcons from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent;

  try {
    // Use the provided icon component directly
    IconComponent = icon || (name && FiIcons[`Fi${name}`]);
  } catch (e) {
    console.warn('Icon loading failed:', e);
    IconComponent = null;
  }

  // Fallback to a simple alert triangle if icon fails
  return IconComponent ? (
    React.createElement(IconComponent, props)
  ) : (
    <FiIcons.FiAlertTriangle {...props} />
  );
};

export default SafeIcon;